import checkUserIsAdvisor from '@actions/advisor/isAdvisor';
import LanguageSelector from '@components/LanguageSelector';
import AuthenticationService from '@lib/auth/AuthenticationService';
import { VERSION_LITE, WALLED_GARDEN, HOMEPAGE_BUTTON_LAYOUT_MTU } from '@lib/constants';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoginHomepage from './Buttons/loginHomepage';
import AdvisorButtons from './Modes/advisorButtons';
import LiteButtons from './Modes/liteButtons';
import OfflineButtons from './Modes/offlineButtons';
import ProspectusButtonsV2 from './Modes/prospectButtonsV2';
import ProspectusButtons from './Modes/prospectusButtons';
import WalledGardenButtons from './Modes/walledGardenButtons';

export default function HomepageButtons() {
	const dispatch = useDispatch();

	const [isAdvisor, setIsAdvisor] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const { isOnline } = useSelector((state) => state.user);

	useEffect(() => {
		if (VERSION_LITE) {
			setIsLoading(false);
			setIsAdvisor(false);
			return;
		}

		const verifyAdvisor = async () => {
			const auth = new AuthenticationService();

			let token = auth.getJwtTokenFromStorage();

			if (!token) {
				await auth.refreshToken()(dispatch);
				token = auth.getJwtTokenFromStorage();
			}

			if (!token) {
				setIsLoading(false);
				return;
			}

			const result = await checkUserIsAdvisor(token);

			console.log(result);

			setIsAdvisor(result);
			setIsLoading(false);
		};

		verifyAdvisor();
	}, [dispatch]);

	if (isLoading) {
		return <></>;
	}

	if (isAdvisor) {
		return <AdvisorButtons />;
	}

	if (HOMEPAGE_BUTTON_LAYOUT_MTU) {
		return (
			<>
				<ProspectusButtonsV2 />
				<LoginHomepage />
				<LanguageSelector />
			</>
		);
	}

	if (!isOnline) {
		return <OfflineButtons />;
	}

	// If its not version lite and is walled garden.
	if (!VERSION_LITE && WALLED_GARDEN) {
		return (
			<>
				<WalledGardenButtons />
				<LoginHomepage />
				<LanguageSelector />
			</>
		);
	}

	if (VERSION_LITE) {
		return <LiteButtons />;
	}

	return (
		<>
			<ProspectusButtons />
			<LoginHomepage />
			<LanguageSelector />
		</>
	);
}
